import React, { memo, useState, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import i18next from "i18next";
import { Menu, MenuItem } from "@material-ui/core";
import avatar from "../../../common/icons/avatar1.png";
import { emoji } from "../../../common/emoji";
import { renderTime } from "../../../utils";
import MessageStatus from "./messageStatus";
import { EaseChatContext } from "../index";
var useStyles = makeStyles(function (theme) {
  return {
    pulldownListItem: {
      display: "flex",
      padding: "10px 0",
      listStyle: "none",
      marginBottom: "26px",
      position: "relative",
      flexDirection: function flexDirection(props) {
        return props.bySelf ? "row-reverse" : "row";
      },
      alignItems: "center"
    },
    userName: {
      padding: "0 10px 4px",
      color: "#8797A4",
      fontSize: "14px",
      display: function display(props) {
        return props.chatType !== "singleChat" && !props.bySelf ? "inline-block" : "none";
      },
      textAlign: function textAlign(props) {
        return props.bySelf ? "right" : "left";
      }
    },
    textBodyBox: {
      display: "flex",
      flexDirection: function flexDirection(props) {
        return props.bySelf ? "inherit" : "column";
      },
      maxWidth: "65%",
      alignItems: function alignItems(props) {
        return props.bySelf ? "inherit" : "unset";
      }
    },
    textBody: {
      // display: "flex",
      margin: function margin(props) {
        return props.bySelf ? "0 10px 10px 0" : "0 0 10px 10px";
      },
      lineHeight: "20px",
      fontSize: "14px",
      background: function background(props) {
        return props.bySelf ? "linear-gradient(124deg, #c913df 20%,#154DFE 90%)" : "#F2F2F2";
      },
      color: function color(props) {
        return props.bySelf ? "#fff" : "#000";
      },
      border: "1px solid #fff",
      borderRadius: function borderRadius(props) {
        return props.bySelf ? "16px 16px 4px 16px" : "16px 16px 16px 4px";
      },
      padding: "15px",
      maxWidth: "65%",
      wordBreak: "break-all",
      textAlign: "initial"
    },
    time: {
      position: "absolute",
      fontSize: "11px",
      height: "16px",
      color: "rgba(1, 1, 1, .2)",
      lineHeight: "16px",
      textAlign: "center",
      top: "-18px",
      width: "100%"
    },
    read: {
      fontSize: "10px",
      color: "rgba(0,0,0,.15)",
      margin: "3px"
    },
    avatarStyle: {
      height: "40px",
      width: "40px",
      borderRadius: "50%"
    }
  };
});
var initialState = {
  mouseX: null,
  mouseY: null
};

function TextMessage(_ref) {
  var message = _ref.message,
      onRecallMessage = _ref.onRecallMessage,
      showByselfAvatar = _ref.showByselfAvatar;
  var easeChatProps = useContext(EaseChatContext);
  var onAvatarChange = easeChatProps.onAvatarChange;
  var classes = useStyles({
    bySelf: message.bySelf,
    chatType: message.chatType
  });

  var _useState = useState(initialState),
      state = _useState[0],
      setState = _useState[1];

  var handleClick = function handleClick(event) {
    event.preventDefault();
    setState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4
    });
  };

  var handleClose = function handleClose() {
    setState(initialState);
  };

  var recallMessage = function recallMessage() {
    onRecallMessage(message);
    handleClose();
  };

  var renderTxt = function renderTxt(txt) {
    if (txt === undefined) {
      return [];
    }

    var rnTxt = [];
    var match = null;
    var regex = /(\[.*?\])/g;
    var start = 0;
    var index = 0;

    while (match = regex.exec(txt)) {
      index = match.index;

      if (index > start) {
        rnTxt.push(txt.substring(start, index));
      }

      if (match[1] in emoji.map) {
        var v = emoji.map[match[1]];
        rnTxt.push( /*#__PURE__*/React.createElement("img", {
          key: v,
          alt: v,
          src: require("../../../common/faces/" + v)["default"],
          width: 20,
          height: 20
        }));
      } else {
        rnTxt.push(match[1]);
      }

      start = index + match[1].length;
    }

    rnTxt.push(txt.substring(start, txt.length));
    return rnTxt;
  };

  return /*#__PURE__*/React.createElement("li", {
    className: classes.pulldownListItem
  }, /*#__PURE__*/React.createElement("div", null, !message.bySelf && /*#__PURE__*/React.createElement("img", {
    className: classes.avatarStyle,
    src: avatar,
    onClick: function onClick() {
      return onAvatarChange && onAvatarChange(message);
    }
  }), showByselfAvatar && message.bySelf && /*#__PURE__*/React.createElement("img", {
    className: classes.avatarStyle,
    src: avatar
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textBodyBox
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.userName
  }, message.from), /*#__PURE__*/React.createElement("div", {
    className: classes.textBody,
    onContextMenu: handleClick
  }, renderTxt(message.body.msg)), message.bySelf && /*#__PURE__*/React.createElement(MessageStatus, {
    status: message.status,
    style: {
      marginTop: message.chatType === "singleChat" ? "0" : "22px"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.time
  }, renderTime(message.time)), message.status === "read" ? /*#__PURE__*/React.createElement("div", {
    className: classes.read
  }, i18next.t("Read")) : null, message.bySelf ? /*#__PURE__*/React.createElement(Menu, {
    keepMounted: true,
    open: state.mouseY !== null,
    onClose: handleClose,
    anchorReference: "anchorPosition",
    anchorPosition: state.mouseY !== null && state.mouseX !== null ? {
      top: state.mouseY,
      left: state.mouseX
    } : undefined
  }, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: recallMessage
  }, i18next.t("withdraw"))) : null);
}

export default memo(TextMessage);